/**
 * Use in containers with a background color of #1D232C or bg-gray-900
 * to blend the fade away color with the background
 */
export const FADE_AWAY_BG_COLORS = {
  '--fade-away-to-dark': 'rgb(29 35 44 / 0)',
  '--fade-away-from-dark': 'rgb(29 35 44)',
} as React.CSSProperties;
